import { registerAnomalyMessages } from '../i18n'

import { registerDashboardWidget } from '@/features/dashboards'
import { registerReportMessages } from '@/features/reports'
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, i18n, type SupportedLocale } from '@/shared/i18n'

function activeLocale(): SupportedLocale {
  const locale = i18n.global.locale.value
  return (SUPPORTED_LOCALES as readonly string[]).includes(locale)
    ? (locale as SupportedLocale)
    : DEFAULT_LOCALE
}

/** Register module 28's lazy anomaly embed without coupling module 09 back to this feature. */
export function registerAnomalyDashboardWidget(): void {
  registerDashboardWidget('anomalies', async () => {
    const locale = activeLocale()
    const [component] = await Promise.all([
      import('../components/AnomaliesWidget.vue'),
      registerReportMessages(locale),
      registerAnomalyMessages(locale),
    ])
    return component
  })
}
